import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projets from './pages/Projets';
import ProjetsList from './pages/ProjetsList';
import Promoteurs from './pages/Promoteurs';
import Salaries from './pages/Salaries';
import Pointages from './pages/Pointages';
import Rentabilite from './pages/Rentabilite';
import ProvisionsAssurance from './pages/ProvisionsAssurance';
import Tresorerie from './pages/Tresorerie';
import Charges from './pages/Charges';
import Parametres from './pages/Parametres';
import Factures from './pages/Factures';
import Absences from './pages/Absences';
import MesPointages from './pages/MesPointages';
import MesAbsences from './pages/MesAbsences';
import Reporting from './pages/Reporting';
import LiensUtiles from './pages/LiensUtiles';
import RemunerationDirigeants from './pages/RemunerationDirigeants';
import AnalyseTemporelle from './pages/AnalyseTemporelle';
import Encaissements from './pages/Encaissements';
import Hub from './pages/Hub';

function RootRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return user.role === 'admin' ? <Hub /> : <MesPointages />;
}

function MesAbsencesRoute() {
  const { user } = useAuth();
  return user?.role === 'admin' ? <Absences /> : <MesAbsences />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><RootRoute /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requireAdmin><Dashboard /></ProtectedRoute>} />
            <Route path="/projets" element={<ProtectedRoute requireAdmin><Projets /></ProtectedRoute>} />
            <Route path="/projets-list" element={<ProtectedRoute><ProjetsList /></ProtectedRoute>} />
            <Route path="/promoteurs" element={<ProtectedRoute requireAdmin><Promoteurs /></ProtectedRoute>} />
            <Route path="/salaries" element={<ProtectedRoute requireAdmin><Salaries /></ProtectedRoute>} />
            <Route path="/pointages" element={<ProtectedRoute><Pointages /></ProtectedRoute>} />
            <Route path="/factures" element={<ProtectedRoute requireAdmin><Factures /></ProtectedRoute>} />
            <Route path="/absences" element={<ProtectedRoute requireAdmin><Absences /></ProtectedRoute>} />
            <Route path="/mes-absences" element={<ProtectedRoute><MesAbsencesRoute /></ProtectedRoute>} />
            <Route path="/rentabilite" element={<ProtectedRoute requireAdmin><Rentabilite /></ProtectedRoute>} />
            <Route path="/provisions" element={<ProtectedRoute requireAdmin><ProvisionsAssurance /></ProtectedRoute>} />
            <Route path="/tresorerie" element={<ProtectedRoute requireAdmin><Tresorerie /></ProtectedRoute>} />
            <Route path="/charges" element={<ProtectedRoute requireAdmin><Charges /></ProtectedRoute>} />
            <Route path="/parametres" element={<ProtectedRoute requireAdmin><Parametres /></ProtectedRoute>} />
            <Route path="/reporting" element={<ProtectedRoute requireAdmin><Reporting /></ProtectedRoute>} />
            <Route path="/remuneration-dirigeants" element={<ProtectedRoute requireAdmin><RemunerationDirigeants /></ProtectedRoute>} />
            <Route path="/analyse-temporelle" element={<ProtectedRoute requireAdmin><AnalyseTemporelle /></ProtectedRoute>} />
            <Route path="/encaissements" element={<ProtectedRoute requireAdmin><Encaissements /></ProtectedRoute>} />
            <Route path="/liens-utiles" element={<ProtectedRoute><LiensUtiles /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
